<template>
  <div class="h-full">
    <el-row :gutter="10" class="h-full">
      <el-col :span="4" class="h-full">
        <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
          <el-tree
            :data="leftTreeData"
            :props="defaultProps"
            @node-click="handleNodeClick"
            node-key="ruleId"
            default-expand-all
          >
            <span slot-scope="{ node, data }">
              <span>{{ node.label }}</span>
              <span v-if="data.count"> ({{ data.count }}) </span>
            </span>
          </el-tree>
        </el-card>
      </el-col>
      <el-col :span="20" class="h-full">
        <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
          <selectStandardId @updateStandardId="updateStandardId" />
          <el-select
            v-model="search.entityId"
            @change="getClassList"
            placeholder="请选择类别"
            size="small"
            filterable
            clearable
            :filter-method="filterSelect"
            popper-class="tag_select-popper"
            class="w-200px mr-10px ml-10px"
            ref="selectEntity"
            @clear="clearEntity"
          >
            <el-option :label="search.entityName" :value="search.entityId">
              <el-tree
                ref="tree"
                :data="treeData"
                :props="defaultProps"
                node-key="id"
                default-expand-all
                :filter-node-method="filterNode"
                @node-click="changeClassId"
              >
              </el-tree>
            </el-option>
          </el-select>
          <el-input
            class="w-200px mr-10px"
            v-model="search.keyword"
            size="small"
            placeholder="搜索"
            clearable
          >
          </el-input>
          <el-button type="primary" @click="searchList">搜索</el-button>
          <!-- <el-button type="primary" @click="openAddDialog" :disabled="!$hasAccess('addTo')"
            >添加到</el-button
          >
          <el-button type="primary" @click="openDialog('add')" :disabled="!$hasAccess('create')"
            >新增</el-button
          >
          <el-button type="primary" @click="toEnabled()">启用</el-button>
          <el-button type="danger" @click="delRules('1')" :disabled="!$hasAccess('delete')"
            >删除</el-button
          >
          <el-button @click="importFile" :disabled="!$hasAccess('import')">导入</el-button>
          <el-button @click="exportExcel" :loading="exportLoading" :disabled="!$hasAccess('export')"
            >导出</el-button
          > -->
          <el-table
            border
            :data="tableData"
            v-loading="tableLoading"
            :highlight-current-row="true"
            height="calc(100% - 104px)"
            class="mt-20px"
            ref="fieldTable"
            @selection-change="tableSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="序号" width="60">
              <template slot-scope="scope">
                {{ scope.$index + 1 + (pageInfo.pageNo - 1) * pageInfo.pageSize }}
              </template>
            </el-table-column>
            <el-table-column
              v-for="item in tableFilterHeader"
              :key="item.label"
              :label="`${$t(item.label)}`"
              :prop="item.value"
              :width="item.width"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span v-if="item.value === 'enableStatus'">
                  {{ scope.row.enableStatus ? '未启用' : '启用' }}
                </span>
                <span v-else>{{ scope.row[item.value] }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button size="mini" @click="openDialog('read', scope.row)">查看</el-button>
                <!-- <el-button
                  :disabled="!$hasAccess('update')"
                  size="mini"
                  @click="openDialog('update', scope.row)"
                  >编辑</el-button
                >
                <el-button
                  size="mini"
                  :disabled="!$hasAccess('delete')"
                  @click="delRules('2', scope.row)"
                  >删除</el-button
                > -->
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="mt-20px float-right"
            background
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :current-page.sync="pageInfo.pageNo"
            :page-size="pageInfo.pageSize"
            :page-sizes="$pageSizeAll"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageInfo.total"
          ></el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <!--新增、编辑-->
    <el-dialog
      :title="$t(`${dialogTitle}`)"
      :visible.sync="dialogVisible"
      width="40%"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      v-dialogDrag
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        size="small"
        :disabled="this.dialogType === 'read'"
      >
        <el-form-item :label="$t('规则类型')" prop="type">
          <el-select
            class="w-full"
            v-model="ruleForm.type"
            :placeholder="$t('pleaseSelect')"
            filterable
            clearable
            @change="selectChange"
          >
            <el-option
              v-for="(item, index) in ruleClassList"
              :key="index"
              :label="item.displayName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('ruleDescription')" prop="description">
          <el-input v-model="ruleForm.description" type="textarea" rows="3" clearable></el-input>
        </el-form-item>
        <el-form-item
          v-if="typeName === '规范检查'"
          :label="typeName === '规范检查' ? $t('regularRegularity') : $t('ruleContent')"
          :prop="typeName === '规范检查' ? 'content' : ' '"
        >
          <!--规则类型为【规范检查】时，规则正则为下拉-->
          <el-select
            v-if="typeCode === 'SpecificationCheck'"
            class="w-full"
            v-model="ruleForm.content"
            :placeholder="$t('pleaseSelect')"
            filterable
            clearable
          >
            <el-option
              v-for="(item, index) in regularList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-input
            v-else
            v-model="ruleForm.content"
            type="textarea"
            rows="3"
            :placeholder="typeName === '规范检查' ? $t('请填写规则正则') : $t('请填写规则内容')"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('status')" prop="enableStatus">
          <el-radio-group v-model="ruleForm.enableStatus">
            <el-radio v-for="item in radioList" :key="item.id" :label="item.id">{{
              item.name
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <div>选择校验范围</div>
        <el-table
          :data="checkRangeList"
          :highlight-current-row="true"
          height="240px"
          class="mt-20px"
          border
        >
          <el-table-column label="实体名称">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.classId"
                placeholder="请选择实体名称"
                @change="ruleFormClassChange($event, scope.$index)"
                filterable
                clearable
              >
                <el-option
                  v-for="item in treeData"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="属性名称">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.classAttributeId"
                placeholder="请选择属性名称"
                filterable
                clearable
              >
                <el-option
                  v-for="item in scope.row.attributeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="数据标签">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.dataLabelId"
                placeholder="请选择数据标签"
                multiple
                filterable
                clearable
              >
                <el-option
                  v-for="item in dataLabelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column width="80" v-if="!ruleForm.id">
            <template slot-scope="scope">
              <i
                class="el-icon-circle-plus-outline text-24px mr-10px cursor-pointer"
                @click="addRow(scope.row)"
              ></i>
              <i
                class="el-icon-remove-outline text-24px cursor-pointer"
                v-if="checkRangeList.length > 1 && !ruleForm.id"
                @click="reduceRow(scope.$index)"
              ></i>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <el-row class="tc" slot="footer">
        <el-button
          v-if="dialogType !== 'read'"
          type="primary"
          size="small"
          @click="submitForm('ruleForm')"
          :loading="loading.save"
          >保存</el-button
        >
        <el-button size="small" @click="beforeClose">取消</el-button>
      </el-row>
    </el-dialog>
    <!--添加到-->
    <el-dialog
      :title="$t('添加到任务')"
      :visible.sync="dialogTask"
      width="70%"
      :close-on-click-modal="false"
      v-dialogDrag
    >
      <el-table
        ref="taskTable"
        :data="taskData"
        maxHeight="500"
        style="width: 100%"
        border
        stripe
        highlight-current-row
        @row-click="rowClick"
        @selection-change="handleSelectionChange"
        v-loading="taskLoading"
      >
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column
          type="index"
          width="55"
          :label="$t('seqNo')"
          align="center"
        ></el-table-column>
        <el-table-column prop="name" :label="$t('title')"></el-table-column>
        <el-table-column prop="runStatus" :label="$t('runningStatus')">
          <template slot-scope="scope">
            {{ _.get(_.find(runStatusList, { id: scope.row.runStatus }), 'name') }}
          </template>
        </el-table-column>
        <el-table-column
          prop="executionFrequency"
          :label="$t('frequencyOfExecution')"
        ></el-table-column>
        <el-table-column
          prop="lastRunTime"
          :label="$t('lastRunTime')"
          width="160"
        ></el-table-column>
        <el-table-column prop="lastRunStatus" :label="$t('lastRunStatus')">
          <template slot-scope="scope">
            {{ _.get(_.find(runStatusList, { id: scope.row.lastRunStatus }), 'name') }}
          </template>
        </el-table-column>
        <el-table-column
          prop="lastRunTakeTime"
          :label="$t('elapsedLastRunSeconds')"
        ></el-table-column>
        <el-table-column
          prop="nextRunTime"
          :label="$t('nextRunTime')"
          width="160"
        ></el-table-column>
      </el-table>
      <el-row class="mt-20px">
        <el-pagination
          class="r"
          background
          @size-change="taskSizeChange"
          @current-change="taskNoChange"
          :current-page="taskpage.pageNo"
          :page-sizes="$pageSizeAll"
          :page-size="taskpage.pageSize"
          layout="->, total, sizes, prev, pager, next"
          :total="taskpage.total"
        ></el-pagination>
      </el-row>
      <el-row slot="footer">
        <el-button type="primary" size="small" @click="saveTaskData">{{ $t('save') }}</el-button>
        <el-button size="small" @click="dialogTask = false">{{ $t('cancel') }}</el-button>
      </el-row>
    </el-dialog>
    <!-- 导入 -->
    <wiz-upload-file
      v-dialogDrag
      @refreshList="searchList"
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
    ></wiz-upload-file>
  </div>
</template>

<script>
import StdClassTreeService from '@/services/StdClassTreeService'
import dataRuleSettingService from '@/services/DataRuleSettingService'
import dataLabelManagementService from '@/services/dataLabelManagementService'
import QualityTaskService from '@/services/QualityTaskService'
import fnMixin from '@/assets/js/fnMixins'
import selectStandardId from '../../components/selectStandardId'

export default {
  name: 'dataRuleSetting',
  mixins: [fnMixin],
  components: {
    selectStandardId,
  },
  data() {
    return {
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      dialogTitle: '',
      dialogVisible: false,
      dialogType: '',
      defaultProps: {
        label: 'name',
        children: 'children',
      },
      leftTreeData: [
        {
          name: '规则树',
          count: 0,
          children: [],
        },
      ],
      search: {
        ruleId: '',
        classId: '',
        keyword: '',
        entityId: '',
        entityName: '',
        stdId: localStorage.getItem('standardId'), // 选择的库
      },
      treeData: [],
      ruleClassList: [],
      tableData: [],
      tableLoading: false,
      pageInfo: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      tableFilterHeader: [
        { value: 'standardName', label: '标准名称' },
        { value: 'className', label: '数据表名称' },
        { value: 'classAttributeCode', label: '属性编码' },
        { value: 'classAttributeName', label: '属性名称' },
        { value: 'ruleName', label: '规则类别' },
        { value: 'ruleDescription', label: '规则描述' },
        { value: 'content', label: '规则内容' },
        { value: 'enableStatus', label: '状态' },
      ],
      loading: {
        field: false,
        table: false,
        save: false,
      },
      ruleForm: {
        enableStatus: 0,
        content: '',
        classInfos: [],
      },
      rules: {
        type: [{ required: true, message: '请选择规则类别', trigger: 'blur' }],
        content: [{ required: true, message: '请输入规则内容', trigger: 'blur' }],
      },
      taskpage: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      checkList: [],
      dialogTask: false,
      runStatusList: [
        { id: 0, name: '执行成功' },
        { id: 1, name: '执行失败' },
        { id: 2, name: '取消执行' },
        { id: 3, name: '待执行' },
        { id: 4, name: '暂停' },
        { id: 5, name: '执行中' },
        { id: 6, name: '执行完成' },
        { id: 7, name: '运行中' },
      ],
      taskData: [],
      taskLoading: false,
      radioList: [
        { id: 0, name: '启用' },
        { id: 1, name: '未启用' },
      ],
      typeName: '',
      typeCode: '',
      exportLoading: false,
      ruleFormCopy: null,
      filterText: '',
      dataLabelList: [],
      checkRangeList: [
        {
          classId: '',
          classAttributeId: '',
          dataLabelId: '',
          attributeList: [],
        },
      ],
      selectionLists: [],
    }
  },
  computed: {
    isChange() {
      return !_.isEqual(this.ruleForm, this.ruleFormCopy)
    },
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    },
    'search.stdId': {
      handler(newVal) {
        if (newVal) {
          this.getTreeList(newVal)
          this.search.entityId = ''
          this.search.entityName = ''
          this.getClassList()
        }
      },
    },
  },
  created() {
    this.getTreeData()
    this.searchList()
    if (this.search.stdId) {
      this.getTreeList(this.search.stdId)
    }
  },
  activated() {
    this.search.stdId = localStorage.getItem('standardId')
  },
  updated() {
    this.$refs.fieldTable.doLayout()
  },
  methods: {
    // 获取左侧树数据
    async getTreeData() {
      const res = await dataRuleSettingService.getRuleTreeNodes()
      if (res && res.code === 0) {
        res.data.forEach((item) => {
          this.leftTreeData[0].count += item.count
        })
        this.leftTreeData[0].children = res.data
      }
    },
    // 点击树
    handleNodeClick(node) {
      this.search.ruleId = node.ruleId
      this.searchList()
    },
    // 修改实体
    changeClassId(data) {
      this.search.entityId = data.id
      this.search.entityName = data.name
      this.$refs.selectEntity.handleClose()
      this.getClassList()
    },
    // 清除实体
    clearEntity() {
      this.search.entityId = ''
      this.search.entityName = ''
    },
    filterSelect(val) {
      this.filterText = val
    },
    filterNode(value, data) {
      if (!value) return true
      const name = _.toLower(`${data.name}（${data.code}）`)
      return name.indexOf(_.toLower(value)) !== -1
    },
    // 查询类别属性
    async getClassList() {
      this.fieldData = []
      if (!this.search.entityId) {
        return
      }
      this.currentTableName = _.find(this.treeData, { id: this.search.entityId }).tableName
      this.loading.field = true
      const res = await dataRuleSettingService.getClassList({
        class_id: this.search.entityId,
        keyword: this.search.leftKeyword,
      })
      if (res && res.code === 0 && !_.isEmpty(res.data)) {
        this.fieldData = res.data
        const firstRow = _.head(res.data)
        this.attributeClick(firstRow)
        this.$refs.fieldTable.setCurrentRow(firstRow)
      }
      this.loading.field = false
    },
    // 获取树形实体列表
    async getTreeList() {
      this.loading.tree = true
      this.treeData = []
      const parameter = {
        standard_id: this.search.stdId,
        keyword: '',
        dynamic_column_name: '业务主题域',
        approve_status: 1,
      }
      const res = await StdClassTreeService.getTreeListNew(parameter)
      if (res && res.code === 0 && res.data) {
        this.treeData = res.data
        this.formatTreeData(this.treeData)
      }
      this.loading.tree = false
    },
    // 改变树形实体数据结构
    formatTreeData(data) {
      if (_.isEmpty(data)) {
        return []
      }
      const fn = (arr) => {
        _.forEach(arr, (o) => {
          o.children = !_.isEmpty(o.childClassList) ? o.childClassList : o.childDynamic
          fn(o.children)
        })
      }
      fn(data)
    },
    updateStandardId(val) {
      this.search.stdId = val
    },
    // 列表勾选
    tableSelectionChange(selection) {
      this.selectionLists = selection
    },
    // 搜索
    searchList() {
      this.pageInfo.pageNo = 1
      this.getTableList()
    },
    // 获取列表数据
    async getTableList() {
      const res = await dataRuleSettingService.getQualityRuleList({
        standardId: this.search.stdId,
        keyword: this.search.keyword,
        classId: this.search.entityId,
        ruleId: this.search.ruleId,
        skipCount: this.pageInfo.pageSize * (this.pageInfo.pageNo - 1),
        maxResultCount: this.pageInfo.pageSize,
      })
      if (res && res.code === 0) {
        this.tableData = res.data
        this.pageInfo.total = res.totalCount
      }
    },
    handleCurrentChange(num) {
      this.pageNo = num
      this.getTableList()
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.getTableList()
    },
    // 启用
    toEnabled() {
      if (!this.selectionLists.length) {
        this.$message.warning('请选择勾选数据！')
        return
      }
      this.$confirm(this.$t('是否确认启用所选数据？'), this.$t('提示'), {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      })
        .then(async () => {
          const selectedIds = _.map(this.selectionLists, 'id')
          const res = await dataRuleSettingService.toEnabled(selectedIds)
          if (res && res.code === 0) {
            this.$message.success('启用成功')
            this.searchList()
          }
        })
        .catch(() => {})
    },
    // 打开弹窗
    async openDialog(type, row) {
      this.checkRangeList = [
        {
          classId: '',
          classAttributeId: '',
          dataLabelId: '',
          attributeList: [],
        },
      ]
      this.dialogVisible = true
      this.dialogType = type
      // this.dialogTitle = type === 'add' ? '新增规则' : '编辑规则'
      this.dialogTitle = '查看'
      await this.getRuleClassList()
      await this.getDataLabelList()
      if (row && type !== 'add') {
        await this.getRuleDetail(row.id)
        this.typeName = _.get(_.find(this.ruleClassList, { id: this.ruleForm.type }), 'displayName')
        this.typeCode = _.get(_.find(this.ruleClassList, { id: this.ruleForm.type }), 'code')
        this.getRegularList()
      } else {
        this.ruleForm = this.$options.data().ruleForm
      }
      this.ruleFormCopy = _.cloneDeep(this.ruleForm)
    },
    // 获取字典
    async getDic() {
      const res = await dataRuleSettingService.getDic({
        code: 'DATARULETYPE',
      })
      if (res && res.code === 0) {
        return _.head(res.data) || {}
      }
      return {}
    },
    // 获取规则详情
    async getRuleDetail(id) {
      const res = await dataRuleSettingService.getRuleDetail({ id })
      if (res && res.code === 0) {
        this.ruleForm = res.data
        this.checkRangeList = []
        this.checkRangeList.push({
          classId: res.data.classId,
          classAttributeId: res.data.classAttributeId,
          dataLabelId: (res.data.dataLabelId && res.data.dataLabelId.split(',')) || [],
          attributeList: [],
        })
        this.ruleFormClassChange(res.data.classId, 0)
      }
    },
    // 获取规则类别列表
    async getRuleClassList() {
      const dic = await this.getDic()
      if (!_.isEmpty(dic)) {
        const res = await dataRuleSettingService.getRuleClass({
          skipCount: 0,
          maxResultCount: 999,
          dataCategoryId: dic.id,
        })
        if (res && res.code === 0) {
          this.ruleClassList = res.data
        }
      }
    },
    // 关闭前
    beforeClose() {
      if (this.isChange) {
        this.$confirm(this.$t('您尚有未保存的数据是否取消'), this.$t('提示'), {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning',
        })
          .then(() => {
            this.closeAndReset()
          })
          .catch(() => {})
      } else {
        this.closeAndReset()
      }
    },
    closeAndReset() {
      this.dialogVisible = false
      this.$refs.ruleForm.resetFields()
    },
    selectChange(id) {
      if (id) {
        this.typeName = _.get(_.find(this.ruleClassList, { id: this.ruleForm.type }), 'displayName')
        this.typeCode = _.get(_.find(this.ruleClassList, { id: this.ruleForm.type }), 'code')
      } else {
        this.typeName = ''
        this.typeCode = ''
      }
      this.ruleForm.content = ''
      if (this.typeCode === 'SpecificationCheck') {
        this.getRegularList()
      }
    },
    // 获取规则正则下拉
    async getRegularList() {
      const res = await dataRuleSettingService.getRegularList()
      if (res && res.code === 0) {
        this.regularList = res.data
      }
    },
    // 添加到任务-勾选
    handleSelectionChange(val) {
      this.checkList = val
    },
    // 导入
    importFile() {
      this.uploadFileProps.visible = true
      this.uploadFileProps.active = 0
    },
    // 下载导入模板
    async exportTemplate() {
      const res = await dataRuleSettingService.downloadTemplate()
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: '数据规则设置导入模板.xlsx',
          data: res,
        })
      }
    },
    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append(key, value)
      })
      formData.append('standardId', this.standardId)
      const res = await dataRuleSettingService.import(formData)
      if (res) {
        this.uploadFileProps.active = 2
        this.downLoadBlob({
          name: '数据规则设置导入明细.xlsx',
          data: res,
        })
        this.getClassList()
      }
      this.uploadFileProps.btnLoading = false
    },
    // 文件导出
    async exportExcel() {
      if (this.search.entityId === '') {
        this.$message.warning(this.$t('pleaseSelectClass'))
        return
      }
      this.exportLoading = true
      const params = {
        standardId: this.search.stdId,
        stdClassId: this.search.entityId,
        stdClassAttributeIds: this.stdClassAttributeIds,
      }
      const res = await dataRuleSettingService.export(params)
      this.exportLoading = false
      if (res) {
        this.downLoadExcel('数据规则设置导出结果.xlsx', res)
      }
    },
    // 删除
    delRules(type, row) {
      let selectionIds = []
      if (type === '1' && !this.selectionLists.length) {
        this.$message.warning('请选择勾选数据！')
        return
      }
      if (this.selectionLists.length) {
        selectionIds = this.selectionLists.map((item) => {
          return item.id
        })
      }
      if (type === '2' && row) {
        selectionIds = [row.id]
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await dataRuleSettingService.remove(selectionIds)
          if (res && res.code === 0) {
            this.$message.success('删除成功')
            this.searchList()
            this.selectionLists = []
          }
        })
        .catch(() => {})
    },
    // 保存校验
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.save()
        }
      })
    },
    // 保存
    async save() {
      let isValid = true
      this.ruleForm.classInfos = []
      this.checkRangeList.forEach((item) => {
        if (!item.classId || !item.classAttributeId) {
          this.$message.warning('请选择校验范围！')
          isValid = false
        } else {
          isValid = true
          if (this.ruleForm.id) {
            this.ruleForm.classId = item.classId
            this.ruleForm.classAttributeId = item.classAttributeId
            this.ruleForm.dataLabelId = (item.dataLabelId && item.dataLabelId.join(',')) || ''
          } else {
            this.ruleForm.classInfos.push({
              classId: item.classId,
              classAttributeId: item.classAttributeId,
              dataLabelId: (item.dataLabelId && item.dataLabelId.join(',')) || '',
            })
          }
        }
      })
      if (!isValid) return

      this.loading.save = true
      let res
      const params = {
        ...this.ruleForm,
      }
      if (this.ruleForm.id) {
        res = await dataRuleSettingService.update({
          model: params,
        })
      } else {
        res = await dataRuleSettingService.createList(params)
      }
      if (res && res.code === 0) {
        this.$message.success('保存成功')
        this.closeAndReset()
        this.searchList()
      }
      this.loading.save = false
    },
    // 添加到任务-打开弹窗
    openAddDialog() {
      if (!this.search.ruleId) {
        this.$message.warning('请选择规则')
        return
      }
      if (!this.selectionLists.length) {
        this.$message.warning('请勾选数据！')
        return
      }
      this.dialogTask = true
      this.getTaskList()
    },
    // 获取任务列表
    async getTaskList() {
      this.taskLoading = true
      const res = await QualityTaskService.getList({
        pageno: this.taskpage.pageNo,
        pageSize: this.taskpage.pageSize,
      })
      this.taskLoading = false
      if (res && res.code === 0) {
        this.taskData = res.data
        this.taskpage.total = res.page ? res.page.recordCount : 0
      }
    },
    // 添加到任务-分页
    taskSizeChange(val) {
      this.taskpage.pageSize = val
      this.getTaskList()
    },
    // 添加到任务-分页
    taskNoChange(val) {
      this.taskpage.pageNo = val
      this.getTaskList()
    },
    // 添加到任务-保存
    async saveTaskData() {
      if (_.isEmpty(this.checkList)) {
        this.$message.warning('请选择任务进行添加')
        return
      }
      const params = {
        taskIds: _.map(this.checkList, 'id'),
        ruleIds: _.map(this.selectionLists, 'id'),
      }
      const res = await dataRuleSettingService.addToTask(params)
      if (res && res.code === 0) {
        this.$message.success('保存成功')
        this.dialogTask = false
        this.searchList()
      }
    },
    // 添加到任务-点击行
    rowClick(row) {
      if (!_.find(this.checkList, { id: row.id })) {
        this.checkList.push(row)
        this.$refs.taskTable.toggleRowSelection(row, true)
      } else {
        this.checkList = _.filter(this.checkList, (item) => {
          return item.id !== row.id
        })
        this.$refs.taskTable.toggleRowSelection(row, false)
      }
    },
    // 获取数据标签下拉数据
    async getDataLabelList() {
      const res = await dataLabelManagementService.list()
      if (res && res.code === 0) {
        this.dataLabelList = res.data
      }
    },
    // 表格添加行
    addRow(row) {
      const tempRow = {
        ...row,
        num: this.checkRangeList.length + 1,
      }
      this.checkRangeList.push(tempRow)
    },
    // 删除行
    reduceRow(index) {
      this.checkRangeList.splice(index, 1)
    },
    // 表格选择实体
    async ruleFormClassChange(e, rowIndex) {
      // 获取属性下拉数据
      const res = await dataRuleSettingService.getClassList({
        class_id: e,
      })
      if (res && res.code === 0) {
        this.checkRangeList[rowIndex].attributeList = res.data
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.el-popper.tag_select-popper .el-select-dropdown__item {
  height: 100% !important;
  padding: 0;
}

</style>
